export const ENDORSEMENT_STEPS = Object.freeze({
  MTE_SETTINGS: 'Settings',
  INSURED_INFORMATION: 'InsuredInformation',
  DETAILS: 'Details',
  DOMAIN: 'Domain',
  INDUSTRY: 'Industry',
  OWNERSHIP: 'Ownership',
  ORG_CONTACT: 'OrgContact',
  FORMS: 'Forms',
  COVERAGES: 'Coverages',
  MTE_SUMMARY: 'Summary',
});

export type EndorsementSteps =
  (typeof ENDORSEMENT_STEPS)[keyof typeof ENDORSEMENT_STEPS];

export const ENDORSEMENT_CATEGORIES = Object.freeze([
  {
    label: 'Organization',
    templateKeys: [
      ENDORSEMENT_STEPS.INSURED_INFORMATION,
      ENDORSEMENT_STEPS.OWNERSHIP,
      ENDORSEMENT_STEPS.ORG_CONTACT,
    ],
  },
  {
    label: 'Business profile',
    templateKeys: [
      ENDORSEMENT_STEPS.DETAILS,
      ENDORSEMENT_STEPS.DOMAIN,
      ENDORSEMENT_STEPS.INDUSTRY,
    ],
  },
  {
    label: 'Underwriting & coverage',
    templateKeys: [ENDORSEMENT_STEPS.FORMS, ENDORSEMENT_STEPS.COVERAGES],
  },
]);

export const UNCATEGORISED_LABEL = 'Other';

export const INDUSTRY_STEP_FIELDS = Object.freeze([
  'naicsCode',
  'primaryIndustry',
  'secondaryIndustry',
  'industryClass',
  'primaryNaicsPercentage',
  'secondNaicsCode',
  'secondPrimaryIndustry',
  'secondSecondaryIndustry',
  'sicCode',
  'sicPrimaryDesc',
  'sicSecondaryDesc',
] as const);
